import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React from 'react';
import groupImage from '../../../../public/Images/PopupGroup.png';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import uploadIcon from '../../../../public/Images/PopupIcons/uploadIcon.png';
import analysisIcon from '../../../../public/Images/PopupIcons/analysisIcon.png';
import reportGeneratedIcon from '../../../../public/Images/PopupIcons/reportGeneratedIcon.png';
import reportIcon from '../../../../public/Images/PopupIcons/reportIcon.png';
import riskRegisterIcon from '../../../../public/Images/PopupIcons/riskRegisterIcon.png';
import loader from '../../../../public/Images/PopupIcons/loader.gif';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { DottedText } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Link } from 'react-router-dom';
import type { CSSObject } from 'tss-react';

export interface OnBoardingPopUpProps {
  title: string;
  subTitle: string;
  statusTitles: string[];
  locateTitle: string;
  locateLink: string;
  rootStyles?: CSSObject;
  infoLabel?: string;
}
interface StyleProps {
  statusTitles: string[];
}

const OnBoardingPopUp: React.FC<OnBoardingPopUpProps> = ({
  statusTitles,
  locateTitle,
  locateLink,
  title,
  subTitle,
  rootStyles = {},
  infoLabel,
}) => {
  const iconData = [
    uploadIcon,
    analysisIcon,
    reportIcon,
    reportGeneratedIcon,
    riskRegisterIcon,
  ];
  const useStyles = makeStyles<StyleProps>()((theme, { statusTitles }) => ({
    root: {
      border: '1px solid' + patientAccessTheme.palette.grey[300],
      borderRadius: '4px',
      gap: '24px',
      padding: '24px',
      alignItems: 'center',
      flexWrap: 'wrap',
      ...rootStyles,
    },
    rootStatusBar: {
      display: 'grid',
      gridTemplateColumns: `repeat(${statusTitles.length * 2 - 1}, 1fr)`, // icon - dash - icon - dash...
      alignItems: 'center',
      gap: '0px',
    },
    statusContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      flex: 1,
    },
    statusBarTitle: {
      display: 'flex',
      gap: '8px',
      alignItems: 'center',
    },
    body: {
      display: 'flex',
      gap: '24px',
      marginTop: '24px',
      alignItems: 'top',
    },
    leftCard: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      borderRadius: '8px',
      border: '1px solid' + patientAccessTheme.palette.grey[300],
      padding: '24px',
      gap: '20px',
      justifyContent: 'center',
    },

    cardContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    estSection: {},

    navigationTitle: {
      display: 'inline-block',
      borderBottom: '1px solid' + patientAccessTheme.palette.primary[500],
      borderBottomStyle: 'dashed',
    },
  }));

  const { classes } = useStyles({ statusTitles });

  return (
    <Grid className={classes.root}>
      <Grid className={classes.rootStatusBar}>
        {statusTitles.map((item, index) => (
          <React.Fragment key={`status-${index}`}>
            <Grid className={classes.statusContainer}>
              <Grid className={classes.statusBarTitle}>
                <img src={iconData[index]} alt="icon" />
                <Typography
                  style={{ whiteSpace: 'nowrap' }}
                  lineHeight="24px"
                  fontType="medium"
                  fontSize="14px"
                  textColor={patientAccessTheme.palette.AIQChips?.textColor3}
                >
                  {item}
                </Typography>
              </Grid>
            </Grid>
            {index < statusTitles.length - 1 && (
              <Grid
                style={{
                  height: '1px',
                  backgroundColor:
                    index >= 2
                      ? patientAccessTheme.palette.grey[300]
                      : patientAccessTheme.palette.primary[500],
                  alignSelf: 'center',
                  marginLeft: '8px',
                  marginRight: '8px',
                }}
              />
            )}
          </React.Fragment>
        ))}
      </Grid>
      <Grid className={classes.body}>
        <Grid className={classes.leftCard}>
          <Grid className={classes.cardContent}>
            <Grid>
              <img src={reportGeneratedIcon} alt="I" />
            </Grid>
            <Typography fontType="semiBold" fontSize="16px" lineHeight="140%">
              {title}
            </Typography>
            <Typography
              fontType="regular"
              lineHeight="-2%"
              fontSize="14px"
              textColor={patientAccessTheme.palette.AIQChips?.textColor3}
            >
              {subTitle}
            </Typography>
            <Grid
              style={{
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
              }}
            >
              <Grid>
                <img src={loader} alt="img" width="32px" height="32px" />
              </Grid>
              <Typography
                fontType="regular"
                lineHeight="24px"
                fontSize="14px"
                textColor={patientAccessTheme.palette.AIQChips?.textColor3}
              >
                Est. Time: 60m
              </Typography>
            </Grid>
          </Grid>
          <Grid className={classes.cardContent}>
            <Typography
              fontType="regular"
              lineHeight="140%"
              fontSize="12px"
              textColor={patientAccessTheme.palette.text.lowemphasis}
            >
              {infoLabel ??
                'You can return to the homepage to check the status.'}
            </Typography>
            <Link
              to={{
                pathname: locateLink,
              }}
              style={{ width: 'fit-content' }}
            >
              <DottedText
                text={locateTitle}
                typographyStyles={{
                  fontSize: '12px',
                  lineHeight: '24px',
                  fontWeight: 600,
                  color: patientAccessTheme.palette.primary[500],
                }}
              />
            </Link>
          </Grid>
        </Grid>
        <Grid
          style={{
            flex: 1,
          }}
        >
          <img src={groupImage} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OnBoardingPopUp;
